// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"ff68962b","213":"df4e78aa","223":"41315d09","239":"5226942e","453":"e8342148","667":"16a5c553"}[chunkId] + ".chunk.js";
};